import React from 'react'
import { Button, Input, Checkbox, Icon, Switch } from 'antd'

function FilterBar({
  searchTerm,
  onSearchChange,
  activeFilterTypes,
  onFilterTypeToggle,
  onReset,
  onRefresh,
  loading,
  myAlertsOnly = false,
  onToggleMyAlerts,
  isDark = false
}) {
  const surface = isDark ? 'rgba(67, 79, 90, 0.96)' : 'rgba(255, 255, 255, 0.9)'
  const border = isDark ? '#495762' : '#dfe1e6'
  const muted = isDark ? '#a1a1a1' : 'rgba(0,0,0,0.45)'
  const inputBg = isDark ? '#3b4550' : '#ffffff'
  const inputText = isDark ? '#E0E0E0' : '#172b4d'

  const filterTypes = [
    { key: 'alertType', label: 'Alert Type' },
    { key: 'status', label: 'Status' },
    { key: 'alertDate', label: 'Alert Date' },
    { key: 'location', label: 'Location' },
    { key: 'subLocation', label: 'Sub Location' },
    { key: 'assetModel', label: 'Asset Model' },
    { key: 'assetType', label: 'Asset Type' },
    { key: 'assetSubType', label: 'Asset Sub Type' },
    { key: 'severity', label: 'Severity' },
    { key: 'assignee', label: 'Assignee' }
  ]

  return (
    <div
      style={{
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        borderBottom: `1px solid ${border}`,
        background: surface,
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backdropFilter: 'blur(8px)'
      }}
    >
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 11, color: muted, marginRight: 4 }}>Filter by:</span>
          {filterTypes.map((filterType) => (
            <Checkbox
              key={filterType.key}
              checked={activeFilterTypes.includes(filterType.key)}
              onChange={(e) => onFilterTypeToggle(filterType.key, e.target.checked)}
              style={{ fontSize: 11, color: inputText }}
            >
              {filterType.label}
            </Checkbox>
          ))}
        </div>
        <Input
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          prefix={<Icon type="search" />}
          placeholder="Search by body text, Alert ID, Asset Code, Owner Code, Alt Name..."
          allowClear
          style={{ width: '20%', background: inputBg, color: inputText, borderColor: border }}
        />
        {onToggleMyAlerts && (
          <span
            style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 5 }}
            title="Show only alerts assigned to me"
          >
            <Switch
              size="small"
              checked={myAlertsOnly}
              onChange={(checked) => onToggleMyAlerts(checked)}
            />
            <span style={{ fontSize: 11, color: inputText }}>My Alerts</span>
          </span>
        )}
        <Button size="small" onClick={onReset} style={{ marginTop: 15 }}>
          Reset
        </Button>
        <Button
          icon="reload"
          onClick={onRefresh}
          loading={loading}
          shape="circle"
          style={{ marginLeft: 'auto', marginTop: 15 }}
        />
      </div>
    </div>
  )
}

export default React.memo(FilterBar)
